import {useEffect, useState} from 'react';
import { arrayMove } from '@dnd-kit/sortable';

export const useSortableList = (externalItems) => {
    const [items, setItems] = useState([]);

    // Поддержка обновления items извне (после загрузки)
    useEffect(() => {
        if (externalItems?.length > 0) {
            setItems(externalItems || []);
        }
    }, [externalItems]);

    const handleDragEnd = (event) => {
        const { active, over } = event;
        if (!over || active.id === over.id) return items;

        const oldIndex = items.findIndex(item => item.id === active.id);
        const newIndex = items.findIndex(item => item.id === over.id);
        if (oldIndex === newIndex || oldIndex === -1 || newIndex === -1) return items;
        const newItems = arrayMove(items, oldIndex, newIndex);
        setItems(newItems || []);
        return newItems
    };

    return {
        items,
        handleDragEnd,
        setItems,
    };
};